// extracted by mini-css-extract-plugin
export default {"rootCom":"Rootcomponent_rootCom__ugU+R","others":"Rootcomponent_others__NG7EB"};